/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type HideMcpServerRequestBody = {
  /**
   * The MCP server.
   */
  mcpServerId: string;
};

/** @internal */
export type HideMcpServerRequestBody$Outbound = {
  mcp_server_id: string;
};

/** @internal */
export const HideMcpServerRequestBody$outboundSchema: z.ZodMiniType<
  HideMcpServerRequestBody$Outbound,
  HideMcpServerRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function hideMcpServerRequestBodyToJSON(
  hideMcpServerRequestBody: HideMcpServerRequestBody,
): string {
  return JSON.stringify(
    HideMcpServerRequestBody$outboundSchema.parse(hideMcpServerRequestBody),
  );
}
